import React from 'react'
import { Table, Typography } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { IMovementRS } from '../../../../models/storageModel'
import { groupMovementsByStorehouse, TStorehouseMovementGroup } from '../../../../utils/reportUtils'
import { TExcelColumn } from '../../../../utils/excelExport'
import { textNumberFormater } from '../../../../utils'

const { Text } = Typography

interface MovementsByStorehouseReportProps {
  data: IMovementRS[]
  storehouseMap: Map<string | number, string>
  loading?: boolean
}

export const storehouseExcelColumns: TExcelColumn[] = [
  { header: 'Almacén', key: 'storehouseName', width: 25 },
  { header: 'Nº Entradas', key: 'entriesCount', width: 14, format: 'number' },
  { header: 'Monto Entradas', key: 'entriesAmount', width: 18, format: 'money' },
  { header: 'Nº Salidas', key: 'exitsCount', width: 14, format: 'number' },
  { header: 'Monto Salidas', key: 'exitsAmount', width: 18, format: 'money' },
  { header: 'Balance Neto', key: 'netBalance', width: 18, format: 'money' }
]

export function getStorehouseExcelData(data: IMovementRS[], storehouseMap: Map<string | number, string>) {
  return groupMovementsByStorehouse(data, storehouseMap)
}

export const MovementsByStorehouseReport: React.FC<MovementsByStorehouseReportProps> = ({
  data,
  storehouseMap,
  loading = false
}) => {
  const groupedData = groupMovementsByStorehouse(data, storehouseMap)

  const columns: ColumnsType<TStorehouseMovementGroup> = [
    {
      title: '#',
      key: 'index',
      width: 50,
      render: (_, __, index) => index + 1
    },
    {
      title: 'Almacén',
      dataIndex: 'storehouseName',
      key: 'storehouseName',
      render: (text) => <strong>{text}</strong>
    },
    {
      title: 'Nº Entradas',
      dataIndex: 'entriesCount',
      key: 'entriesCount',
      width: 120,
      align: 'right',
      render: (count) => textNumberFormater(count)
    },
    {
      title: 'Monto Entradas',
      dataIndex: 'entriesAmount',
      key: 'entriesAmount',
      width: 150,
      align: 'right',
      render: (val) => <Text style={{ color: '#52c41a' }}>$ {textNumberFormater(val)}</Text>
    },
    {
      title: 'Nº Salidas',
      dataIndex: 'exitsCount',
      key: 'exitsCount',
      width: 120,
      align: 'right',
      render: (count) => textNumberFormater(count)
    },
    {
      title: 'Monto Salidas',
      dataIndex: 'exitsAmount',
      key: 'exitsAmount',
      width: 150,
      align: 'right',
      render: (val) => <Text style={{ color: '#ff4d4f' }}>$ {textNumberFormater(val)}</Text>
    },
    {
      title: 'Balance Neto',
      dataIndex: 'netBalance',
      key: 'netBalance',
      width: 160,
      align: 'right',
      sorter: (a, b) => a.netBalance - b.netBalance,
      render: (val) => (
        <Text strong style={{ color: val >= 0 ? '#1890ff' : '#fa8c16' }}>
          $ {textNumberFormater(val)}
        </Text>
      )
    }
  ]

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <Table<TStorehouseMovementGroup>
        columns={columns}
        dataSource={groupedData}
        loading={loading}
        pagination={false}
        size="small"
        bordered
        scroll={{ x: 'max-content' }}
      />
    </div>
  )
}

export default MovementsByStorehouseReport
